"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2806],{

/***/ 30516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _percentPart = _interopRequireDefault(__webpack_require__(96453));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var __jsx = _react["default"].createElement;
var PriceProgress = function PriceProgress(props) {
  var currentPrice = props.currentPrice,
    limitPrice = props.limitPrice,
    progressColor = props.progressColor;
  var translations = {
    freeDelivery: (0, _langLibrary["default"])("Free delivery"),
    toFreeDelivery: (0, _langLibrary["default"])("to free standard shipping")
  };
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var amountToFreeDelivery = __jsx(_Box["default"], {
    as: "span"
  }, priceWithCurrency(limitPrice - currentPrice), __jsx(_Box["default"], {
    as: "span"
  }, "\xA0", translations.toFreeDelivery));
  var percentWidth = currentPrice >= limitPrice ? 100 : (0, _percentPart["default"])(currentPrice, limitPrice);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      flexBasis: "100%",
      font: "body2",
      color: "main"
    }
  }, currentPrice >= limitPrice ? translations.freeDelivery : amountToFreeDelivery), __jsx(_Box["default"], {
    sx: {
      flexBasis: "100%",
      minHeight: "12px",
      maxHeight: "12px",
      borderColor: "neutral500",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "7px",
      my: "s6",
      p: "s1",
      bg: "neutral300",
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "8px",
      backgroundColor: progressColor || "active",
      borderRadius: "7px",
      position: "absolute",
      zIndex: "2",
      top: "1px",
      left: "1px",
      width: percentWidth + "%",
      transition: "width 0.2s ease-out"
    }
  })));
};
var _default = PriceProgress;
exports.Z = _default;

/***/ }),

/***/ 96453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var percentPart = function percentPart(part, total) {
  return Math.floor(part / total * 100);
};
var _default = percentPart;
exports["default"] = _default;

/***/ }),

/***/ 12806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_PriceProgress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30516);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PriceProgress = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_PriceProgress__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["default"] = (PriceProgress);


/***/ })

}]);